import { Component, OnInit} from '@angular/core';
import { SubmissionSearchObject, SubmissionSearchUserInfoObject } from '../search-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {DateUtil} from '../date-util';
import * as _moment from 'moment';
import {KpiService} from '../../../shared/services/kpi.service';
import {MatRadioChange} from '@angular/material/radio';

const moment = _moment;

@Component({
    selector: 'kpi-search',
    templateUrl: './kpi-search.component.html',
    styleUrls: [ './kpi-search.component.scss' ],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: DateUtil.MY_FORMATS}
      ]
})
export class KpiSearchComponent implements OnInit {

    date = new FormControl(moment());
    minDate = new Date(2000, 0, 1);
    maxDate = new Date();
    searchCriteria = new SubmissionSearchObject();
    userSearchInfo = new SubmissionSearchUserInfoObject();
    totalSampleCount: number;

    ngOnInit() {
        this.submissionHistoryService.currentUserInfo.subscribe(message => this.userSearchInfo = message);
        this.kpiService.currentKpiSearchCriteria.subscribe(message => this.searchCriteria = message);
        this.kpiService.currentTotalSampleSearchCount.subscribe(message => this.totalSampleCount = message);
        this.searchCriteria.submissionIdentifierType = 'Submissions';
    }

    constructor(private submissionHistoryService: SubmissionHistoryService, private kpiService: KpiService) {
        this.searchCriteria.submissionIdentifierType = 'Submissions';
    }

    docTypeChange(docTypeRadio: MatRadioChange) {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        if (DateUtil.validateDateTime(startDate.value) && DateUtil.validateDateTime(endDate.value)) {
            const startDateTime = startDate.value + ' ' + startTime.value;
            const endDateTime = endDate.value + ' ' + endTime.value;
            this.searchCriteria.submissionIdentifierType = docTypeRadio.value;
            if (docTypeRadio.value != "Samples") {
                this.kpiService.triggerKpiSearch(this.searchCriteria, startDateTime.trim(), endDateTime.trim());
            } else {
                this.kpiService.clearSearchResults();
            }
        } else {
            return;
        }
    }

    onSubmitUpdateKpi() {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        if (DateUtil.validateDateTime(startDate.value) && DateUtil.validateDateTime(endDate.value)) {
            const startDateTime = startDate.value + ' ' + startTime.value;
            const endDateTime = endDate.value + ' ' + endTime.value;
            this.kpiService.triggerKpiSearch(this.searchCriteria, startDateTime.trim(), endDateTime.trim());
        } else {
            return;
        }
    }

    public updateTableDataSearch(search: SubmissionSearchObject): void {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        const startDateTime = startDate.value + ' ' + startTime.value;
        const endDateTime = endDate.value + ' ' + endTime.value;
    }

    clear() {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;
        const startTime = document.querySelector('#startTime') as HTMLInputElement;
        const endTime = document.querySelector('#endTime') as HTMLInputElement;

        this.searchCriteria = new SubmissionSearchObject();
        startDate.value = ''
        endDate.value = ''
        startTime.value = ''
        endTime.value = ''
        this.searchCriteria.submissionIdentifierType = 'Submissions';
        this.kpiService.clearSearchResults();
    }

    public onStartDateChange(searchValue: string) {
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            document.querySelector( '#startDateFormField' ).classList.remove( 'mat-form-field-invalid' )
        } else {
            document.querySelector( '#startDateFormField' ).classList.add( 'mat-form-field-invalid' )
        }
    }

    public onEndDateChange(searchValue: string) {
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            document.querySelector( '#endDateFormField' ).classList.remove( 'mat-form-field-invalid' )
        } else {
            document.querySelector( '#endDateFormField' ).classList.add( 'mat-form-field-invalid' )
        }
    }

    public onStartDateSelected() {
        document.querySelector( '#startDateFormField' ).classList.remove( 'mat-form-field-invalid' )
    }

    public onEndDateSelected() {
        document.querySelector( '#endDateFormField' ).classList.remove( 'mat-form-field-invalid' )
    }
}
